"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-fragments */
// @ts-nocheck
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const shift_1 = require("@app/component/modals/shift-1.5/shift");
const Tooltip_1 = require("@app/component/ui/tooltip/Tooltip");
const use_modal_hoc_1 = require("@app/util/modal/use-modal-hoc");
const connect_1 = __importDefault(require("./connect"));
require("./index.scss");
const HOURS = util_1.timeUtil.hours();
// onDrag fires a lot, skip some
let cooldown = false;
// we need to know real row width
// to convert drag distance into minutes
let rowWidth = null;
function onRowRef(row) {
    if (row?.offsetWidth) {
        rowWidth = row.offsetWidth;
    }
}
class Shifts extends react_1.default.Component {
    handleOnClick;
    handleOnStart;
    handleOnMove;
    handleOnEnd;
    constructor(props) {
        super(props);
        this.state = {
            shiftHash: null,
            beforeDrag: null,
            delta: null,
            change: null,
            prevX: null,
        };
        this.handleOnClick = this._onClick.bind(this);
        this.handleOnStart = this._onStart.bind(this);
        this.handleOnMove = this._onMove.bind(this);
        this.handleOnEnd = this._onEnd.bind(this);
    }
    _getX(e) {
        if (e.clientX)
            return e.clientX;
        const ret = window.dragPageX || 0;
        if (ret < 0)
            return 0;
        return ret;
    }
    componentDidMount() {
        // set up the drag&drop handler 'document.ondragover'
        document.ondragover = (e) => {
            window.dragPageX = e.pageX;
            window.dragPageY = e.pageY;
        };
    }
    _onClick(shiftHash, e) {
        const { templateId, readOnly, quickActionsTooltipOnClick } = this.props;
        if (readOnly)
            return;
        if (quickActionsTooltipOnClick) {
            if (e.target) {
                const tooltip = e.target.parentNode.querySelector(':scope > .is-qa-tooltip-on-click');
                if (tooltip)
                    tooltip.click();
            }
            return;
        }
        if (templateId) {
            this.props.openModal(shift_1.ShiftModal, {
                initialData: {
                    type: 'template',
                    templateId,
                    shiftId: shiftHash,
                },
            });
        }
    }
    _onStart(e, shiftHash, change) {
        this.setState({
            change,
            shiftHash,
            beforeDrag: this._getX(e),
            delta: 0,
        });
    }
    _onMove(e) {
        // only run update when X value changed
        const currX = this._getX(e);
        const beforeDrag = this.state.beforeDrag ?? 0;
        const shouldUpdate = (0, util_1.isNull)(this.state.prevX) || this._getX(e) !== this.state.prevX;
        // only run update after certain delay
        if (cooldown)
            return;
        cooldown = true;
        setTimeout(() => {
            cooldown = false;
        }, 30);
        if (!shouldUpdate) {
            return;
        }
        this.setState({
            delta: currX - beforeDrag,
            prevX: currX,
        });
    }
    _onEnd(e) {
        const { beforeDrag, shiftHash } = this.state;
        this.setState({
            delta: this._getX(e) - (beforeDrag ?? 0),
        }, async () => {
            const { editTemplateShift, templateId, customEditShiftFunction } = this.props;
            let st = this.getStart(this.modifiedShift());
            if (st >= 1440)
                st -= 1440;
            if (st < 0)
                st += 1440;
            const update = {
                start: st,
                duration: this.getDuration(this.modifiedShift()),
            };
            if (customEditShiftFunction) {
                await customEditShiftFunction(shiftHash, update);
            }
            else {
                await editTemplateShift(templateId, shiftHash, update);
            }
            this.setState((s) => Object.assign({}, s, { change: null, prevX: null }));
        });
    }
    modifiedShift() {
        const { shiftHash } = this.state;
        return this.props.shifts.find((sf) => sf.hash === shiftHash);
    }
    getMinDelta() {
        return Math.round((this.state.delta / rowWidth) * 24 * 60);
    }
    getStart(sf) {
        const modSf = this.modifiedShift();
        if (!modSf ||
            modSf.hash !== sf.hash ||
            !['start', 'both'].includes(this.state.change)) {
            return sf.start;
        }
        // 15 minute steps
        const newStart = Math.round((modSf.start + this.getMinDelta()) / 15) * 15;
        if (newStart < 0) {
            return 0;
        }
        return newStart;
    }
    getDuration(sf) {
        const modSf = this.modifiedShift();
        if (!modSf ||
            modSf.hash !== sf.hash ||
            !['duration', 'both'].includes(this.state.change)) {
            return sf.duration;
        }
        let newDuration = 0;
        if (this.state.change === 'duration') {
            newDuration = modSf.duration + this.getMinDelta();
            if (newDuration < 60) {
                newDuration = 60;
            }
        }
        if (this.state.change === 'both') {
            if (this.getStart(modSf) === 0) {
                newDuration = modSf.start + modSf.duration;
            }
            else {
                newDuration = modSf.duration - this.getMinDelta();
            }
        }
        // 15 minute steps
        return Math.round(newDuration / 15) * 15;
    }
    render() {
        const { sm, isFiltered, isLoading, workspace, templateId, hideShiftsCountSection, readOnly, customPositions, customDeleteShiftFunction, isCreatingShifts, isDeletingShifts, deleteTemplateShift, } = this.props;
        let { positions, shifts } = this.props;
        const minRows = this.props.minRows || 10;
        if (!positions?.length)
            positions = customPositions;
        if (!positions?.length)
            return null;
        if (isFiltered) {
            shifts = util_1.sortUtil.sortByKey(shifts, 'disabled');
        }
        const cN = ['ds-shifts'];
        if (sm)
            cN.push('is-sm');
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: cN.join(' ') },
                react_1.default.createElement("div", { className: 'ds-shifts-head ds-focus-day-template' }, HOURS.map((hr) => (react_1.default.createElement("div", { key: hr, className: 'ds-sh-col' }, parseInt(hr) % 6 === 0 ? hr : '  ')))),
                react_1.default.createElement("div", { className: 'ds-shifts-hours' }, HOURS.map((hr) => {
                    if (sm && hr % 6 !== 0)
                        return null;
                    return react_1.default.createElement("div", { key: hr, className: 'ds-shifts-hour' });
                })),
                shifts.map((sf, i) => {
                    const position = positions.find((pos) => pos.id === sf.positionId);
                    if (!position)
                        return null;
                    const color = position.color || util_1.colorUtil.idToColor(position.id, positions);
                    const start = this.getStart(sf);
                    const duration = this.getDuration(sf);
                    const isOverflow = start + duration > 24 * 60;
                    const cN = ['ds-shifts-row'];
                    const locality = sf.localityId && workspace && workspace.localities
                        ? workspace.localities.find((l) => l.id === sf.localityId)
                        : null;
                    if (isOverflow)
                        cN.push('is-overflow');
                    if (isFiltered && sf.disabled)
                        cN.push('is-disabled');
                    return (react_1.default.createElement("div", { key: sf.hash + i.toString(), className: cN.join(' '), ref: onRowRef, style: { zIndex: 1 + (shifts.length - i) } },
                        react_1.default.createElement("div", { className: 'ds-shifts-shift', style: {
                                left: util_1.timeUtil.relMin(start),
                                width: util_1.timeUtil.relMin(duration),
                                background: `#${color}`,
                                color: util_1.colorUtil.contrastText(color) === 'light' ? 'white' : 'black',
                            } },
                            !isLoading && !readOnly && (react_1.default.createElement("div", { className: 'ds-ss-stretch is-forward' },
                                react_1.default.createElement("div", { className: 'ds-ss-stretch-drag', draggable: true, onDragStart: (e) => this.handleOnStart(e, sf.hash, 'both'), onDrag: this.handleOnMove, onDragEnd: this.handleOnEnd }))),
                            isLoading ? (react_1.default.createElement("div", { className: 'ds-ss-loading' },
                                react_1.default.createElement(_ui_1.Loader, { size: _ui_1.Loader.SIZES.TINY }))) : (react_1.default.createElement(Tooltip_1.Tooltip, { canBeHovered: true, position: Tooltip_1.Tooltip.POSITIONS.BOTTOM_END, width: '11.875rem', anchor: react_1.default.createElement("div", { className: 'ds-ss-drag', draggable: true, onDragStart: (e) => {
                                        this.handleOnStart(e, sf.hash, 'start');
                                    }, onDrag: this.handleOnMove, onDragEnd: this.handleOnEnd }) }, this.state.change === null ||
                                this.state.change?.length === 0 ? (react_1.default.createElement("div", { style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.75rem',
                                    padding: '0.5rem',
                                    alignItems: 'start',
                                }, onClick: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                } },
                                templateId && (react_1.default.createElement(_ui_1.Button, { style: 'BORDERLESS', color: 'DEFAULT', onClick: (e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.handleOnClick(sf.hash, e);
                                    } },
                                    react_1.default.createElement(_ui_1.Icon, { ico: 'edit' }),
                                    (0, util_1.t)('EDIT'))),
                                react_1.default.createElement(_ui_1.Button, { style: 'BORDERLESS', disabled: isCreatingShifts, onClick: (e) => {
                                        // create the copies
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.props.createTemplateShift(templateId, {
                                            start: sf.start,
                                            duration: sf.duration,
                                            positionId: sf.positionId,
                                            idealSkill: sf.idealSkill,
                                            localityId: sf.localityId,
                                            pauses: sf.pauses,
                                            pausesFixed: sf.pausesFixed,
                                            copies: 1,
                                            requirementsArrayIndex: i + 1,
                                            agenda: sf.agenda,
                                        });
                                    } },
                                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.duplicate }),
                                    (0, util_1.t)('DUPLICATE')),
                                react_1.default.createElement(_ui_1.Button, { style: 'BORDERLESS', color: 'RED', disabled: isDeletingShifts, onClick: (e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        if (customDeleteShiftFunction) {
                                            customDeleteShiftFunction(sf.hash);
                                        }
                                        else {
                                            deleteTemplateShift(this.props.templateId, sf);
                                        }
                                    } },
                                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.delete }),
                                    (0, util_1.t)('DELETE')))) : null)),
                            react_1.default.createElement("div", { className: 'ds-ss-title' },
                                position.name,
                                locality ? ' (' + (locality.shortName ?? '??') + ')' : ''),
                            !isLoading && (react_1.default.createElement("div", { className: 'ds-ss-time' },
                                react_1.default.createElement("div", { className: 'ds-ss-time-left' }, util_1.timeUtil.formatMinutes(start)),
                                react_1.default.createElement("div", { className: 'ds-ss-time-mid' },
                                    sf.pauses?.length
                                        ? sf.pauses.length === 1
                                            ? (0, util_1.t)('PAUSE_SHORT_X', {
                                                dur: sf.pauses[0].duration.toString() + 'm',
                                                start: (0, moment_1.default)('1970-01-01')
                                                    .startOf('day')
                                                    .add(sf.start + (sf.pauses[0].start ?? 0), 'minutes')
                                                    .format('H:mm'),
                                            })
                                            : sf.pauses.length.toString() +
                                                ' ' +
                                                (0, util_1.t)('PAUSES_SHORT').toLowerCase()
                                        : '',
                                    sf.pauses && sf.pauses.length === 0 && sf.pausesFixed
                                        ? (0, util_1.t)('PAUSE_NO_PAUSE')
                                        : ''),
                                react_1.default.createElement("div", { className: 'ds-ss-time-right' }, util_1.timeUtil.formatMinutes(start + duration)))),
                            !isLoading && !readOnly && (react_1.default.createElement("div", { className: 'ds-ss-stretch' },
                                react_1.default.createElement("div", { className: 'ds-ss-stretch-drag', draggable: true, onDragStart: (e) => this.handleOnStart(e, sf.hash, 'duration'), onDrag: this.handleOnMove, onDragEnd: this.handleOnEnd })))),
                        !sm && (react_1.default.createElement("div", { className: 'ds-shifts-row-add', onClick: (e) => {
                                this.props.openModal(shift_1.ShiftModal, {
                                    initialData: {
                                        type: 'template',
                                        templateId: this.props.templateId,
                                        templateAddToRequirementsArrayIdx: i + 1,
                                    },
                                });
                            } },
                            react_1.default.createElement(_ui_1.Flex, { align: _ui_1.Flex.POSITION.CENTER },
                                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.plus, size: _ui_1.Icon.SIZES.SMALL }),
                                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                                react_1.default.createElement(_ui_1.Text, { text: (0, util_1.t)('ADD'), type: _ui_1.Text.TYPES.BODY_LARGE, color: _ui_1.Text.COLORS.PRIMARY }))))));
                }),
                [...Array(Math.max(0, minRows - shifts.length)).keys()].map((i) => (react_1.default.createElement("div", { key: i, className: 'ds-shifts-row' },
                    react_1.default.createElement("div", { className: 'ds-shifts-row-add', onClick: (e) => {
                            this.props.openModal(shift_1.ShiftModal, {
                                initialData: {
                                    type: 'template',
                                    templateId: this.props.templateId || undefined,
                                    templateAddToRequirementsArrayIdx: shifts.length,
                                },
                            });
                            // this.props.setModal('extra-shift', {
                            //   type: 'template',
                            //   day: 'day-template',
                            //   templateId: this.props.templateId || undefined,
                            //   templateAddToRequirementsArrayIdx: shifts.length
                            // })
                        } }, '+ ' + (0, util_1.t)('ADD')))))),
            shifts?.length && !hideShiftsCountSection ? (react_1.default.createElement("div", { className: 'ds-shifts-shift-counter' },
                react_1.default.createElement("div", null, (0, util_1.t)('SHIFTS_ON_POS')),
                react_1.default.createElement("div", { className: 'ds-shifts-counts' }, positions.map((pos, i) => {
                    const shiftsCount = shifts.filter((sf) => sf.positionId === pos.id).length;
                    if (!shiftsCount)
                        return null;
                    return (react_1.default.createElement("div", { className: 'ds-shifts-count-badge', key: i, style: {
                            background: `#${pos.color || util_1.colorUtil.idToColor(pos.id, positions)}`,
                            color: util_1.colorUtil.contrastText(pos.color || util_1.colorUtil.idToColor(pos.id, positions)) === 'light'
                                ? 'white'
                                : 'black',
                        } },
                        react_1.default.createElement("span", { className: 'ds-shifts-count-badge-pos' }, pos.name),
                        react_1.default.createElement("span", null,
                            " ",
                            shiftsCount)));
                })))) : null));
    }
}
exports.default = (0, connect_1.default)((0, use_modal_hoc_1.withUseModalHOC)(Shifts));
